class ItemInventoryMovementModel {
  private _serverData: any;

  constructor(serverData: any = null) {
    this._serverData = serverData;
  }

  get event_at(): string {
    return this._serverData?.event_at || '';
  }

  get event_type(): string {
    return this._serverData?.event_type || '';
  }

  get qty(): string {
    const value = this._serverData?.qty;
    return value === null || value === undefined ? '' : String(value);
  }

  get balance(): string {
    const value = this._serverData?.balance;
    return value === null || value === undefined ? '' : String(value);
  }

  get reason(): string {
    const value = this._serverData?.reason;
    return value === null || value === undefined ? '' : String(value);
  }

  get created_by_name(): string {
    const value = this._serverData?.created_by_name;
    return value === null || value === undefined ? '' : String(value);
  }

  static fromServerData(serverData: any) {
    return new ItemInventoryMovementModel(serverData);
  }
}

class ItemInventoryMovementsModel {
  private _serverData: any;

  constructor(serverData: any = null) {
    this._serverData = serverData;
  }

  get movements(): ItemInventoryMovementModel[] {
    const data = this._serverData?.movements;
    if (!Array.isArray(data)) {
      return [];
    }
    return data.map((item: any) => ItemInventoryMovementModel.fromServerData(item));
  }

  static fromServerData(serverData: any) {
    return new ItemInventoryMovementsModel(serverData);
  }

  static createEmpty() {
    return new ItemInventoryMovementsModel({ movements: [] });
  }
}

export default ItemInventoryMovementsModel;
export { ItemInventoryMovementModel };
